import { gql } from "@apollo/client";

export const UPDATE_MULTIPLE_SUBSCRIPTION_PAYMENT_METHOD = gql`
mutation updateMultipleSubscriptionPaymentMethod(
  $wellnessIds: [String!]!, $cardId: String!
) {
  updateMultipleSubscriptionPaymentMethod(wellnessIds: $wellnessIds, cardId: $cardId) {
    failedWellnessIds
    successfulWellnessIds
    success
    messages
  }
}`;
